<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
      <div class="col-md-9 ps-5">
        <h2 class="col pb-2 title">
          {{ "ANALYSISREPORTMENU_PREPAYMENTREPORT" | translate }}
        </h2>
        <h6 class="col subtitle"> {{ "PREPAYMENTREPORT_DETAILS" | translate }} </h6>
      </div>
      <div class="col-md-3 d-flex justify-content-end align-items-center pe-5">
        @if (
        authService.isAuthorized([PermissionsEnum.Report_prepayment_download])
        ) {
        <button class="col-auto add justify-content-center" (click)="download()">
          {{ "DOWNLOAD" | translate }}
        </button>
        }
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
        <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
        <div class="datepicker-container-wrapper position-relative">
          <div class="button-wrapper pe-2">
            <div class="button">
              <img alt="Date" src="assets/core/table-button/date.svg" />
              <div class="button-text" (click)="toggleModal()"
                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                  {{ selectedDate }}
                </ng-container>
                <ng-template #noDateSelected>
                  <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                </ng-template>
              </div>
              <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
                (click)="clearDates()" />
            </div>
          </div>
          @if (isDatepickerOpen) {
          <div class="overlay" (click)="toggleModal()"></div>
          <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
            [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
          }
        </div>
        <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
          (searchChange)="searchChange($event)"></app-search>
        <div class="button-wrapper-gray m-2">
          <div class="button" (click)="reloadTable()" title="Reload table">
            <div><img alt="Refresh" src="assets/device/refresh.svg" /></div>
          </div>
        </div>
      </div>


      <div class="row g-0 m-0 pt-3">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "ENERGYREGISTERS_METERNO" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "DEVICESETUP_METERTYPE" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "REPORT_RECHARGE_AMOUNT" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "REPORT_TOKEN_NUMBER" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "REPORT_CAPTURED_DATA_TIME" | translate }}</span>
              </th>
              <th>
                <img alt="Column" src="assets/device/column-menu.svg" />
                <span>{{ "REPORT_RECHARGE_UNIT" | translate }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data; let i=index">
              <td appIsNew [executedTime]="row.capturedTime!" [seconds]="dayInMs"></td>
              <td>
                <span (click)="clipboardService.copyToClipboard(row.meterNumber!, $event, i)" class="copyable">
                  {{ row.meterNumber }}
                  <span class="copy-tooltip" *ngIf="clipboardService.copiedText === i.toString()">{{"COPIED" |
                    translate}}</span>
                </span>
              </td>
              <td>
                <span>{{ row.meterType }}</span>
              </td>
              <td>
                <span>{{ row.rechargeAmount }}</span>
              </td>
              <td>
                <span>{{ row.tokenNumber }}</span>
              </td>
              <td>
                <span>{{
                  row.capturedTime | date: "dd MMM yyyy, h:mm a"
                  }}</span>
              </td>
              <td>
                <span>{{ row.rechargeUnit || "-" }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="container-down">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfPrepayment" [pageSize]="pageSize"
      [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
  </div>
</div>